var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMedalla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 71,
    viewBox: "0 0 67 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 38.5L27 38L31 41L35.5 38L40 38.5V63L31 58L22 63V38.5Z",
    fill: "#0099CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7028 9.21377C30.411 8.47769 31.589 8.47769 32.2972 9.21377L34.0508 11.0366C34.745 11.7582 35.7535 12.0859 36.7393 11.9102L39.2295 11.4662C40.235 11.287 41.1881 11.9794 41.3283 12.9911L41.6756 15.4966L42.27 15.4142L41.6756 15.4966C41.8131 16.4885 42.4364 17.3463 43.3372 17.7836L45.6127 18.8881C46.5316 19.3341 46.8957 20.4545 46.4144 21.3555L45.2227 23.5866C44.751 24.4698 44.751 25.5302 45.2227 26.4134L46.4144 28.6445C46.8957 29.5455 46.5316 30.6659 45.6127 31.1119L43.3372 32.2164C42.4364 32.6537 41.8131 33.5115 41.6756 34.5034L41.3283 37.0089C41.1881 38.0206 40.235 38.713 39.2295 38.5338L36.7393 38.0898C35.7535 37.9141 34.745 38.2418 34.0508 38.9634L32.2972 40.7862C31.589 41.5223 30.411 41.5223 29.7028 40.7862L27.9492 38.9634C27.255 38.2418 26.2465 37.9141 25.2607 38.0898L22.7705 38.5338C21.765 38.713 20.8119 38.0206 20.6717 37.0089L20.3244 34.5034C20.1869 33.5115 19.5636 32.6537 18.6628 32.2164L16.3873 31.1119C15.4684 30.6659 15.1043 29.5455 15.5856 28.6445L16.7773 26.4134C17.249 25.5302 17.249 24.4698 16.7773 23.5866L15.5856 21.3555C15.1043 20.4545 15.4684 19.3341 16.3873 18.8881L18.6628 17.7836C19.5636 17.3463 20.1869 16.4885 20.3244 15.4966L20.6717 12.9911C20.8119 11.9794 21.765 11.287 22.7705 11.4662L25.2607 11.9102C26.2465 12.0859 27.255 11.7582 27.9492 11.0366L29.7028 9.21377Z",
    fill: "white",
    stroke: "#545E62",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9999,
    cy: 25,
    r: 9,
    stroke: "#545E62",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMedalla);
export default __webpack_public_path__ + "static/media/ico_medalla.83bad065c176ff2aa982dbb6b8e927fb.svg";
export { ForwardRef as ReactComponent };